import React, {useEffect} from 'react'
import Header from './Header'
import Content from './content02'
import Footer from './footer'
// import  Axios from 'axios'

function SearchPage() {
   

useEffect(()=>{

},[])
    
   

    return (
        <div>
            <Header></Header>
            <Content></Content>  
            <Footer></Footer>          
        </div>
    )
}

export default SearchPage
